module.exports = __webpack_public_path__ + "static/media/1.35569028.jpg";